export default function (t, columns) {
  const rowFields = [];
  columns.forEach((column) => {
    if (column.fields.length > 1) {
      column.fields.forEach((field) => {
        rowFields.push({
          title: field.title,
          customProps: {
            align: 'center',
          },
        });
      });
    }
  });

  return rowFields;
}
